import { dehydrate, QueryClient, useQuery } from 'react-query';
import { useRouter } from 'next/router';

import { queryClientConfig } from '@core/configs/queryClientConfig';
import { setSsrTokens } from 'utils/authentication';
import { GetPublicCertificate } from 'services/core';
import { getPublicCertificateSeoProps } from 'router/seoprops';

import { NextSeo } from 'next-seo';

import PublicCertificate from 'components/pages/public-certificates/PublicCertificate';
import Spinner from '@core/components/spinner/Spinner';

import classes from './PublicCertificatePage.module.scss';

const PublicCertificatePage = (props) => {
	const router = useRouter();
	const { uuid } = router.query;

	const { data, isLoading } = useQuery(
		['public-certificate', uuid],
		() => GetPublicCertificate(uuid),
		{ enabled: !!uuid }
	);

	const seoProps = getPublicCertificateSeoProps({ ...props, id: uuid });

	return (
		<>
			<NextSeo {...seoProps} />
			{data && !isLoading ? (
				<PublicCertificate data={data.data} />
			) : (
				<div className={classes['loading']}>
					<Spinner />
				</div>
			)}
		</>
	);
};

export async function getServerSideProps(context) {
	setSsrTokens(context);
	const queryClient = new QueryClient(queryClientConfig);
	const { uuid, slug } = context.params;

	try {
		const response = await GetPublicCertificate(uuid);

		await queryClient.prefetchQuery(
			['public-certificate', uuid],
			() => ({ data: response.data })
		);

		if (slug !== response.data.slug) {
			return {
				redirect: {
					permanent: false,
					destination: `/public-certificates/${uuid}/${response.data.slug}`
				}
			};
		}

		return {
			props: {
				dehydratedState: dehydrate(queryClient),
				name: response.data.name || '',
				title: response.data.lecture?.title || '',
				slug: response.data.slug || '',
				description: response.data.lecture?.description || '',
			}
		};
	} catch (e) {
		if (e.response?.status === 404) {
			return {
				redirect: {
					permanent: false,
					destination: '/404'
				}
			};
		}
		return { notFound: true };
	}
}

export default PublicCertificatePage;
